<script setup lang="ts">
const { spacing = 2, highlighted = false } = defineProps<{
  spacing?: number;
  highlighted?: boolean;
  wrap?: boolean;
}>();

const classNames = computed(() => {
  return [highlighted && 'grid-section__highlighted'];
});

const getSpacing = computed(() => {
  return `${spacing}rem`;
});
</script>

<template>
  <div :class="classNames" class="grid-section container">
    <div v-if="highlighted" class="grid__background" />

    <div class="grid row" :class="{ wrap }">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:color';
@use 'core/colors';
@use 'core/layout/grid-vars';
@use 'core/util';

.grid-section {
  padding: 0;
  position: relative;

  &.grid-section__highlighted {
    padding: grid-vars.space(2);
  }

  .grid.wrap {
    flex-wrap: wrap;
  }

  .grid__background {
    @include util.borders-rounded;

    background-color: color.adjust(colors.color(negative), $alpha: -0.7);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    opacity: 0.5;
  }

  :deep(.grid) {
    --cl-gutter-x: v-bind(getSpacing);
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
